export default __webpack_public_path__ + "static/media/OldTownSquare.29994a92.JPG";